import type { ReferralRewardStatus } from '../dataProvider/types';
import { formatMoney } from '../cashbacks/formatMoney';
import type { RefereeRow } from './referralsModel';

/** Display helpers for the Referrals explorer. */

export const REWARD_LABEL: Record<ReferralRewardStatus, string> = {
  pending: 'Pending',
  qualified: 'Qualified',
  paid: 'Paid',
  void: 'Void',
};

/** Chip colour per reward state: pending neutral, qualified owed (attention),
 *  paid settled, void killed. */
export const REWARD_COLOR: Record<
  ReferralRewardStatus,
  'default' | 'warning' | 'success' | 'error'
> = {
  pending: 'default',
  qualified: 'warning',
  paid: 'success',
  void: 'error',
};

/**
 * The referee's spend progress toward the threshold, shown only on a PENDING
 * referral so ops can read a stalled-but-legit referral from an abandoned fake
 * one. Cross-market is flagged "approx" because spend and threshold are different
 * currencies; this admin never converts (the engine does, at qualification).
 * e.g. "30.00 GBP of 50.00 GBP (60%)", or cross-market "40.00 USD of 50.00 GBP
 * (approx 80%)".
 */
export const formatProgress = (row: RefereeRow): string => {
  const spend = formatMoney(row.qualifyingSpend, row.refereeCurrency);
  const target = formatMoney(row.threshold, row.thresholdCurrency);
  const pct = row.approximate
    ? `approx ${row.progressPct}%`
    : `${row.progressPct}%`;
  return `${spend} of ${target} (${pct})`;
};
